import { MutationTree } from 'vuex';

import { encode } from '@/utils/custom-enc-dec';

import {
  ProjectsStateI,
  ProjectsResultI,
  ProjectI,
  DocumentPaginationI,
  ProjectPaginationI,
} from './state';

export const mutations: MutationTree<ProjectsStateI> = {
  setProjectsResult(state: ProjectsStateI, payload: ProjectsResultI) {
    state.projectsResult = payload;
  },
  setProject(state: ProjectsStateI, payload: ProjectI) {
    state.project = payload;
    const encodedProject = encode(payload);
    localStorage.setItem('project', encodedProject);
  },
  setDocuments(state: ProjectsStateI, payload: DocumentPaginationI) {
    state.documents = payload;
  },
  setProjects(state: ProjectsStateI, payload: ProjectPaginationI) {
    state.projectPagination = payload;
  },
};
